module.exports = __webpack_public_path__ + "img/img16.478bd682.png";